import type { SpecialType } from '@iheartjane/types';

const specialTypePriority: Record<SpecialType, number> = {
  product: 0,
  bundle: 1,
  bulk_pricing: 3,
  cart_total: 4,
  qualified_group: 5,
  spending_threshold: 6,
};

export const bySpecialType = (
  a: { special_type: SpecialType },
  b: { special_type: SpecialType }
) => specialTypePriority[a.special_type] - specialTypePriority[b.special_type];
